import { useTranslation } from "react-i18next";

import DescriptionListItem from "@/components/Elements/DescriptionListItem";
import FieldPreviewWrapper from "@/components/Elements/FieldPreview/FieldPreviewWrapper";
import { useGetObservationRiskMatrix } from "@/entities/observation";
import { ModelList } from "@/modules/model-list";
import { RiskTag } from "@/modules/risk-tag";
import { format, humanizeDays } from "@/utilities/date";

const ObservationSummaryHeader = ({ observation }) => {
  const { t } = useTranslation();

  const { observation_date, source_intervention } = observation;
  const users = source_intervention?.users;

  const { risk, isLoading } = useGetObservationRiskMatrix(observation);
  const riskDueDays = humanizeDays(risk?.due_days);

  return (
    <dl className="observation-summary-header">
      <DescriptionListItem
        labelEllipsis
        id="observation-due-days"
        label={t("observation:dueDays")}
        content={
          <FieldPreviewWrapper value={riskDueDays} loading={isLoading}>
            {riskDueDays}
          </FieldPreviewWrapper>
        }
      />
      <DescriptionListItem
        labelEllipsis
        id="observation-risk"
        label={t("form:staticField:risk.label")}
        content={
          <FieldPreviewWrapper value={risk} loading={isLoading}>
            <RiskTag risk={risk} />
          </FieldPreviewWrapper>
        }
      />
      <DescriptionListItem
        labelEllipsis
        id="observation-date"
        label={t("observation:observationDate")}
        content={format(observation_date)}
      />
      <DescriptionListItem
        labelEllipsis
        id="observation-users"
        label={t("observation:users")}
        content={
          <FieldPreviewWrapper value={users}>
            <ModelList model="user" items={users} withLink />
          </FieldPreviewWrapper>
        }
      />
    </dl>
  );
};

export default ObservationSummaryHeader;
